import { APIClient } from '@frontend/api-utils';

export class WorkflowEnumClient extends APIClient {
    public static readonly endpoint = '/workflow-api/v1';

    public static async fetchGeneralWorkflowTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/general-workflow-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchGeneralWorkflowActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/general-workflow-actions`);
        return await this.handleResponse<string[]>(response);
    }
}
